<template>
  <div id="app">
     
<!-- End Google Tag Manager -->
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-573NV8M"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
    <eheader @showCart="showCart = !showCart"> </eheader>

    <zoom-center-transition>
    <div >
      <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=706564397869270&ev=PageView&noscript=1"/>
      <router-view></router-view>
    </div>
    </zoom-center-transition>
    <slide-x-right-transition :duration='800'>
    </slide-x-right-transition>
    <efooter></efooter>
  </div>
</template>

<script>
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-573NV8M');
  import Eheader from '@/components/layout/Eheader.vue'
  import Efooter from '@/components/layout/Efooter.vue'
  import SingleProduct from '@/components/SingleProduct.vue'
  import ProductModal from '@/components/ProductModal.vue'
  import { SlideXRightTransition,ZoomCenterTransition } from 'vue2-transitions'
 

  export default {
    name: 'app',
    components: {
      Eheader,
      Efooter,
      ProductModal,
      SingleProduct,
      SlideXRightTransition,
      ZoomCenterTransition,
    },
    data() {
      return {
        loading: false,
      }
    },
  }


</script>

<!-- End Meta Pixel Code -->  
<style lang="scss">
  
  @use './assets/styles/price-range.scss';
  @use './assets/styles/animate.scss';
  @use './assets/styles/styles.scss';
  @use './assets/styles/variables.scss';
  @use './assets/styles/responsive.scss';
</style>